import React from 'react';
import type { AccessibilityProps, ImageSourcePropType } from 'react-native';
import { View, StyleSheet } from 'react-native';

import {
  BenefitCardContainer,
  BenefitCardImg,
  BenefitCardText,
  BenefitCardTitle,
} from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const BenefitCard = (props: BenefitCardProps) => {
  const { title, text, imgSource, imgA11yLabel, isUnavailable } = props;

  return (
    <BenefitCardContainer isUnavailable={isUnavailable}>
      {imgSource ? (
        <BenefitCardImg source={imgSource} accessibilityLabel={imgA11yLabel} />
      ) : null}

      <View style={styles.textContent}>
        <BenefitCardTitle>{title}</BenefitCardTitle>
        <BenefitCardText>{text}</BenefitCardText>
      </View>
    </BenefitCardContainer>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  textContent: {
    flex: 1,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type BenefitCardProps = Readonly<{
  title: string;
  text: string;
  imgSource?: ImageSourcePropType;
  imgA11yLabel?: AccessibilityProps['accessibilityLabel'];
  isUnavailable?: boolean;
}>;
